import { Component, computed, input, signal } from '@angular/core';
import { formatAge } from './format-age';
import { HealthCard } from './health-card';
import { AppHealth, STATUS_LABELS } from './models';
import { healthTone, toneClass } from './tone';

// One dense line per role for the list view; opening it shows the full card.
@Component({
  selector: 'app-health-row',
  imports: [HealthCard],
  templateUrl: './health-row.html',
  styleUrl: './health-row.css',
  host: { role: 'listitem' },
})
export class HealthRow {
  readonly app = input.required<AppHealth>();
  readonly now = input(new Date());
  readonly staleAfterMs = input(Infinity);

  // The card is only built once the row is opened.
  protected readonly open = signal(false);

  protected readonly statusLabel = computed(() => STATUS_LABELS[this.app().status]);
  protected readonly rowTone = computed(() => toneClass(healthTone(this.app().status)));
  protected readonly age = computed(() => formatAge(this.app().checkedAt, this.now()));
  protected readonly stale = computed(
    () => this.now().getTime() - new Date(this.app().checkedAt).getTime() > this.staleAfterMs(),
  );
  protected readonly why = computed(() => this.app().statusReason ?? this.app().error ?? '');

  protected onToggle(event: Event): void {
    this.open.set((event.target as HTMLDetailsElement).open);
  }
}
